/**
 * HomeGroupWA Global JS Include
 *
 * @author Red Tiki <info@redtiki.com.au>
 */

// Global function used to update the url params with the preview module (without refreshing the page)

window.previewAppendUrl = function(updateGetVars) {
    var url = new URL(window.location.href);
    $.each(updateGetVars, function(item, val) {
        if (url.searchParams) {
            url.searchParams.set(item, val);
        }
    });
    window.history.pushState({ path: url.href }, '', url.href);
};

var doc = document.documentElement;
doc.setAttribute('data-useragent', navigator.userAgent);
window.__lc = {};
window.LC_API = window.LC_API || {};
window.PageObject = function(opts) {
    var page_obj = {
        currentURL: '',
        pageClass: 'Page',
        pageID: false,
        pageTitle: false,
        pageAction: false,

        currentDivisionID: 0,
        currentDivisionSelector: false,
        currentDivisionTitle: false,

        houseAndLandPackageID: 0,
        homeDesignID: 0,

        livechatReady: false,
        LiveChatEnabled: false,
        livechatAgentAvailable: false,

        onloadGAEvent: false,

        livechatButtonText: {
            online: 'Speak To Us Now',
            offline: 'Contact Us Now'
        },

        isDesktopOrIpadLandscape:
            typeof Modernizr !== 'undefined' ? Modernizr.mq('only all and (min-width: 992px)') : false,
        docHeight: $(document).height(),
        winHeight: $(window).height(),
        pageHeight: 0,
        sidebarHeight: $('#site-sidebar').outerHeight(),
        stickySidebar: false,

        history: [],
        //overlay: new $.overlay(),

        init: function() {
            this.winHeight = $(window).height();
            if (this.currentDivisionSelector) {
                // window.previewAppendUrl({ region: this.currentDivisionSelector });
            }
            this.loadLiveChat();
            this.bindEvents();
            this.onInit();

            return this;
        },

        loadLiveChat: function() {
            if (!this.blockLivechat()) {
                /*livechatinc snippet*/
                window.__lc.license = 5472401;
                (function() {
                    var lc = document.createElement('script');
                    lc.type = 'text/javascript';
                    lc.async = true;
                    lc.src =
                        ('https:' == document.location.protocol ? 'https://' : 'http://') +
                        'cdn.livechatinc.com/tracking.js';
                    var s = document.getElementsByTagName('script')[0];
                    s.parentNode.insertBefore(lc, s);
                })();
                /*end livechatinc snippet*/
            }
        },

        // initLaunchModal: function() {
        //     //Selector vars
        //     let $modalButtons = $('.modal-state-btn');
        //
        //     //Get divisionLocalStorage if available
        //     let isFirstTime = false;
        //     try {
        //         isFirstTime = localStorage.getItem('FIRST_TIME') === null;
        //     } catch (e) {
        //         isFirstTime = true;
        //     }
        //     if ($modalButtons.length && isFirstTime) {
        //         try {
        //             localStorage.setItem('FIRST_TIME', 1);
        //             $('#divisionModal').modal('show');
        //             $modalButtons.on('click', function (e) {
        //                 e.preventDefault();
        //                 $('.division-container')
        //                     .find("[data-state='" + $(this).data('state') + "']")
        //                     .first()
        //                     .click();
        //                 $('#divisionModal').modal('hide');
        //             });
        //         } catch ( e ) {
        //         }
        //     }
        // },

        blockLivechat: function() {
            if (!this.LiveChatEnabled || this.currentDivisionSelector === 'albany-great-southern') {
                return true;
            }

            return false;
        },

        ready: function() {
            var self = this;

            if (this.LiveChatEnabled) {
                $('.btn-livechat').on('click', function(e) {
                    e.preventDefault();
                    self.livechatButtonClicked();
                    return false;
                });
            }

            // Enable Bootstrap tooltips
            $('[data-toggle="tooltip"]').tooltip();

            this.setupModals();
            this.setupAjaxContactForm();
            this.setupSearch();
            self.setupDivisionDropdown();
            this.fireOnloadGAEvent();
            $('.lazyload').lazyload();
        },

        bindEvents: function() {
            var self = this;

            $(document).ready(function() {
                self.ready();
                self.onReady();
            });

            $(window).on('load', function() {
                self.onLoad();
                // self.initLaunchModal();
                self.layoutPage();
            });

            $(window).resize(function() {
                self.onResize();

                // Position sidebar
                self.isDesktopOrIpadLandscape =
                    typeof Modernizr !== 'undefined' ? Modernizr.mq('only all and (min-width: 992px)') : false;
                self.layoutPage();
            });

            $(window).scroll(function() {
                if (self.stickySidebar) {
                    var scrolled = $(document).scrollTop() + self.winHeight,
                        sidebarDiff = Math.min(self.winHeight - self.sidebarHeight, 0); // If sidebar is taller than window

                    //console.log(scrolled + ', ' + self.pageHeight);
                    if (scrolled + sidebarDiff > self.pageHeight) {
                        var pull = self.pageHeight - (scrolled - sidebarDiff);

                        $('.layout-left').css({
                            top: pull
                        });
                    } else {
                        $('.layout-left').css({
                            top: 0
                        });
                    }
                }
            });

            if (!this.blockLivechat()) {
                window.LC_API.on_chat_window_opened = function() {
                    self.trackEvent('livechat', 'chat_opened', self.currentURL);
                    self.onChatOpened();
                };

                window.LC_API.on_chat_started = function() {
                    self.trackEvent('livechat', 'chat_started', self.currentURL);
                    self.onChatStarted();
                };

                window.LC_API.on_after_load = function() {
                    self.livechatReady = true;

                    if (window.LC_API.agents_are_available()) {
                        self.livechatAgentAvailable = true;
                        self.updateLiveChatButton('online');
                        self.onChatAgentsOnline();
                    }

                    self.updateLivechatCustomVariables(self.customLiveChatVariables());
                };

                window.LC_API.on_chat_state_changed = function(data) {
                    switch (data.state) {
                        case 'offline':
                            if (self.livechatAgentAvailable) {
                                self.livechatAgentAvailable = false;
                                self.onChatAgentsOffline();
                            }
                            self.updateLiveChatButton('offline');
                            break;
                        case 'online_for_chat':
                            if (!self.livechatAgentAvailable) {
                                self.livechatAgentAvailable = true;
                                self.updateLiveChatButton('online');
                                self.onChatAgentsOnline();
                            }
                            break;
                        case 'online_for_queue':
                            if (!self.livechatAgentAvailable) {
                                self.livechatAgentAvailable = true;
                                self.updateLiveChatButton('online');
                                self.onChatAgentsOnline();
                            }
                            break;
                    }
                };

                window.LC_API.on_chat_window_minimized = function() {
                    self.trackEvent('livechat', 'chat_minimised', self.currentURL);
                    self.onChatMinimised();
                };

                window.LC_API.on_chat_window_hidden = function() {
                    self.trackEvent('livechat', 'chat_hidden', self.currentURL);
                    self.onChatHidden();
                };
            } else {
                //this.updateLiveChatButton('offline');
            }
        },

        changeDivisionAjax: function(ele) {
            $.ajax({
                url: window.location.protocol + '/home/changeDivisionAjax',
                type: 'POST',
                dataType: 'json',
                data: {
                    DivisionID: ele.attr('value'),
                    CurrentURL: window.location.href
                },
                success: function(data, textStatus, jqXHR) {
                    window.location = data.newURL;
                }
            });
        },

        setupDivisionDropdown: function() {
            var self = this;
            var $stateButtons = $('.state-btn');
            $stateButtons.click(function() {
                $stateButtons.removeClass('selected');
                $(this).addClass('selected');
                $('.division-container').hide();
                $('.division-container[data-state="' + $(this).data('state') + '"]').show();
            });
            $('a.division-selector-item').click(function(e) {
                $('a.division-selector-item').removeClass('selected');
                $(this).addClass('selected');
                e.preventDefault();
                self.changeDivisionAjax($(this));
            });
        },

        layoutPage: function() {
            var addLegacyClass = ['GenericLandingPage'];

            addLegacyClass.forEach(function(element) {
                if ($('body').hasClass(element)) {
                    $('main').addClass('layout-right');
                }
            });

            var self = this;

            (self.docHeight = $(document).height()),
                (self.winHeight = $(window).height()),
                (floorHeight = $('.floor').is(':visible') ? $('.floor').outerHeight() : 0),
                (self.pageHeight = self.docHeight - floorHeight),
                (self.sidebarHeight = $('#site-header').outerHeight());

            // Sticky sidebar > 992px
            if (self.isDesktopOrIpadLandscape) {
                var contentHeight = $('.layout-right').outerHeight();

                // Sticky sidebar only when content on right is taller than sidebar, or there is no "floor"
                self.stickySidebar =
                    floorHeight == 0 || contentHeight - floorHeight > self.sidebarHeight ? true : false;

                if (self.stickySidebar) {
                    // Find height of content
                    var mH = Math.min(contentHeight, self.winHeight);

                    // Pages with no "floor" (eg. Finance, Display Homes)
                    if (floorHeight == 0) {
                        mH = self.winHeight;
                        $('.layout-left').css({
                            overflowY: 'auto',
                            '-webkit-overflow-scrolling': 'touch'
                        });
                    }

                    // Make sure .layout-right is at least as high as window
                    $('.layout-right').css({
                        minHeight: '100vh'
                    });

                    // Make .layout-left 'fixed'
                    $('.layout-left').addClass('sticky');
                } else {
                    // Find height of tallest layout component ($sidebar or .layout-right)
                    var mH = Math.max(self.sidebarHeight, contentHeight);
                    // console.log(self.sidebarHeight, $('.layout-right').outerHeight());
                    // Set .layout-right to this height
                    $('.layout-right').css({
                        minHeight: mH
                    });

                    // Set .layout-left (which contains $sidebar) to this height, and make sure it's not offset
                    $('.layout-left')
                        .css({
                            top: 0,
                            minHeight: mH
                        })
                        .removeClass('sticky');
                }
            } else {
                // Reset
                $('.layout-left, .layout-right').css({
                    top: 0,
                    minHeight: 0,
                    height: 'auto'
                });

                $('.layout-left').removeClass('sticky');
            }
        },

        setupSearch: function() {
            $('.header-gallery').not('.slick-initialized').slick({
                dots: false,
                prevArrow: false,
                nextArrow: false,
                infinite: true,
                autoplay: true,
                loop: true,
                pauseOnHover: true,
                pauseOnFocus: true,
                swipe: true,
                swipeToSlide: true,
                speed: 300,
                slidesToShow: 1,
                centerMode: false,
                variableWidth: true
            });

            $('.searchResultLink').click(function(e) {
                var content = $(this)
                    .parents('.SubSearchResult')
                    .find('.searchContent')
                    .first();

                if (content.is(':visible')) {
                    content.hide();
                } else {
                    content.show();
                }
            });
        },

        setupModals: function() {
            var self = this;
            if (typeof hash !== 'undefined') {
                var hashModal = hash.get('m');
                $('#ContactFormModal').on('show.bs.modal', function(event) {
                    var designID = $(event.relatedTarget).data('design');
                    var packageID = $(event.relatedTarget).data('package');

                    self.onContactFormModalShow(event, $(this));

                    if (designID) {
                        $('#TotemForm_GeneralEnquiryForm_HomeDesignID').val(designID);
                    }
                    if (packageID) {
                        $('#TotemForm_GeneralEnquiryForm_HouseAndLandPackageID').val(packageID);
                    }
                });

                //check to see if any modals have been triggered from the url
                if (hashModal) {
                    UIkit.modal('#' + hashModal).show();
                }
            }
        },

        trackPageView: function(url, title) {
            if (ga) {
                ga('send', 'pageview', {
                    page: url,
                    title: title
                });
            }
        },

        trackEvent: function(category, action, url) {
            if (ga) {
                ga('send', 'event', category, action, { page: url, nonInteraction: 1 });
            }
        },

        //interact with the history stack etc
        changePage: function(url, className, id, title) {
            var current = {
                currentURL: this.currentURL,
                pageClass: this.pageClass,
                pageID: this.pageID,
                pageTitle: this.pageTitle
            };

            this.history.unshift(current);

            this.currentURL = url;
            this.pageClass = className;
            this.pageID = id;
            this.pageTitle = title;

            this.updateLivechatCustomVariables(this.customLiveChatVariables());
        },

        backPage: function() {
            var next = {};
            var current = {
                currentURL: this.currentURL,
                pageClass: this.pageClass,
                pageID: this.pageID,
                pageTitle: this.pageTitle
            };

            if (this.history.length) {
                next = this.history.shift();

                this.currentURL = next.currentURL;
                this.pageClass = next.pageClass;
                this.pageID = next.pageID;
                this.pageTitle = next.pageTitle;
            }

            this.history.unshift(current);

            this.updateLivechatCustomVariables(this.customLiveChatVariables());
        },

        //sometimes we use a compound ID, this strips the extra id components
        cleanPageID: function() {
            //'-'
            var parts;
            var stringID = 'P' + this.pageID;
            if (stringID.indexOf('-') !== -1) {
                parts = stringID.split('-');
                return parts[0];
            }
            return this.pageID;
        },

        changeDivision: function(id, selector, title) {
            this.currentDivisionID = id;
            this.currentDivisionSelector = selector;
            this.currentDivisionTitle = title;
        },

        onContactFormModalShow: function(e, modal) {
            $('#TotemForm_GeneralEnquiryForm_HomeGroupDivisionID').val(this.currentDivisionID);
            $('#TotemForm_GeneralEnquiryForm_PageID').val(this.cleanPageID());
            $('#TotemForm_GeneralEnquiryForm_HouseAndLandPackageID').val(this.houseAndLandPackageID);
            $('#TotemForm_GeneralEnquiryForm_HomeDesignID').val(this.homeDesignID);

            if ($('#HomeDesignModal').is(':visible')) {
                $('#HomeDesignModal')
                    .removeClass('fade')
                    .modal('hide')
                    .addClass('fade');
                //	            $("#HomeDesignModal").modal("hide");
            }
        },

        openContactForm: function() {
            UIkit.modal('#ContactFormModal').show();
        },

        //Livechat integration
        livechatButtonClicked: function() {
            if (this.livechatAgentAvailable) {
                //online
                // confirm this has fixed

                try {
                    window.LC_API.open_chat_window();
                } catch (e) {}
            } else {
                //offline
                this.openContactForm();
            }
        },

        //state can be 'online' or 'offline'
        updateLiveChatButton: function(state) {
            if (state === 'offline') {
                $('.btn-livechat')
                    .removeClass('btn-online')
                    .addClass('btn-offline');
                $('.btn-livechat .chat-text').html(this.livechatButtonText.offline);
            } else {
                $('.btn-livechat')
                    .removeClass('btn-offline')
                    .addClass('btn-online');
                $('.btn-livechat .chat-text').html(this.livechatButtonText.online);
            }
        },

        customLiveChatVariables: function() {
            var customVariables = [
                { name: 'page-type', value: this.pageClass },
                { name: 'page-title', value: this.pageTitle },
                { name: 'page-id', value: this.pageID },
                { name: 'page-url', value: this.currentURL }
            ];
            return customVariables;
        },

        updateLivechatCustomVariables: function(customVariables) {
            if (this.livechatReady) {
                window.LC_API.set_custom_variables(customVariables);
            }
        },

        displayManualOverlay: function(bToggle) {
            var overlayElement = $('.manual-overlay').first();

            if (!overlayElement.length) {
                overlayElement = $('<div class="manual-overlay" />')
                    .hide()
                    .insertAfter('body');
                //overlayElement.on("click", function(){ $(this).hide() });
            }

            bToggle ? $(overlayElement).show() : $(overlayElement).hide();

            //this.overlay.toggleOverlay(bToggle);
        },

        fireOnloadGAEvent: function() {
            if (this.onloadGAEvent) {
                this.trackEvent(this.onloadGAEvent.event, this.onloadGAEvent.title, this.currentURL);
            }
        },

        setupAjaxContactForm: function() {
            $('#TotemForm_CallMeBackEnquiryForm').submit(function(event) {
                event.preventDefault();
                $('#TotemForm_CallMeBackEnquiryForm')
                    .children('.required-field')
                    .hide();
                $.ajax({
                    url: $(this).attr('action'),
                    type: 'POST',
                    data: $('#TotemForm_CallMeBackEnquiryForm').serialize(),
                    success: function(data, textStatus, jqXHR) {
                        $('.chat-tag-call-back .call-back').html('<div class="success"><p>' + data + '</p></div>');
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        $('.chat-tag-call-back .call-back').html(
                            '<div class="failure"><p>An error has occurred, please try again later.</p></div>'
                        );
                    },
                    complete: function() {
                        setTimeout(function() {
                            //$(".chat-tag-call-back").removeClass("active");
                            $.callMeBackOverlay.hideOverlay();
                            //Page.displayManualOverlay(false);
                        }, 3000);
                    }
                });
            });
        },

        onInit: function() {},
        onReady: function() {},
        onResize: function() {},
        onLoad: function() {},

        //livechat events
        onChatStarted: function() {},
        onChatOpened: function() {},
        onChatLoaded: function() {},
        onChatMinimised: function() {},
        onChatHidden: function() {},
        onChatAgentsOffline: function() {},
        onChatAgentsOnline: function() {}
    };

    if (opts) {
        return $.extend(page_obj, opts);
    } else {
        return page_obj;
    }
};
